import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BiometricsDataService } from 'src/app/services/biometrics/biometrics-data.service';
import { BiometricsService } from 'src/app/services/biometrics/biometrics.service';
import { FILE_TYPE_PARAM } from 'src/app/shared/data/biometrics.constants';
import {
  EBiometricsType,
  EscreenKeys,
  IFacialFeaturesMessages
} from 'src/app/shared/interfaces/biometrics.interface';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { LoadingService } from 'src/app/shared/services/loading.service';

@Component({
  selector: 'app-biometrics-launcher',
  template: '',
  styleUrls: ['./biometrics-launcher.component.scss']
})
export class BiometricsLauncherComponent implements OnInit, OnDestroy {
  type: EBiometricsType;
  screenKey = EscreenKeys.LAUNCHER;
  private subscriptions = new Subscription();
  constructor(
    private router: Router,
    private biometricsService: BiometricsService,
    private biometricsDataService: BiometricsDataService,
    private zone: NgZone,
    private activatedRoute: ActivatedRoute,
    public loadingService: LoadingService
  ) {
    this.type = this.activatedRoute.snapshot.paramMap.get(
      FILE_TYPE_PARAM
    ) as EBiometricsType;
  }

  ngOnInit() {
    this.launchTaker();
    this.changeLoading();
  }

  changeLoading() {
    setTimeout(() => {
      const element = document.querySelector('.loading-general');
      element?.classList.add('loading-general-bm');
    }, 10);
  }

  launchTaker() {
    const SDKCODE = this.biometricsDataService.generalData[this.type].codeSDK;
    const ISFRONTAL =
      this.biometricsDataService.generalData[this.type].isFrontal;
    this.loadingService.startLoading();
    let sub = this.biometricsService.startCapture(SDKCODE, ISFRONTAL).subscribe(
      (r: IFacialFeaturesMessages) => {
        this.zone.run(() => {
          console.log(r);
          this.loadingService.stopLoading();
          this.biometricsDataService.resultsFromBiometrics[this.type] = r;
          this.router.navigate([
            this.biometricsDataService.routingBiometrics[this.type][
              this.screenKey
            ].to
          ]);
        });
      },
      (e) => {
        console.log(e);
        this.zone.run(() => {
          if (!e) return;

          this.biometricsService.sendAnaliticError(e);
          console.warn(e);

          if (this.isCaptureFailedEvent(e)) {
            return;
          }

          if (this.isBackButtonEvent(e)) {
            this.loadingService.stopLoading();
            this.router.navigate([
              this.biometricsDataService.routingBiometrics[this.type][
                this.screenKey
              ].previous
            ]);
            return;
          }

          if (this.isPermissionEvent(e)) {
            this.loadingService.stopLoading();
            this.router.navigate([routesData.ERRORS.CAMERA.redirectPath]);
          }
        });
      }
    );
    this.subscriptions.add(sub);
  }

  isCaptureFailedEvent(e: any): boolean {
    return e.StatusCode === 2;
  }

  isBackButtonEvent(e: any): boolean {
    return e.StatusCode === 3;
  }

  isPermissionEvent(e: any): boolean {
    return e.StatusCode === 6;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
